import { render, staticRenderFns } from "./extremeRules.vue?vue&type=template&id=62d62948&"
import script from "./extremeRules.vue?vue&type=script&lang=js&"
export * from "./extremeRules.vue?vue&type=script&lang=js&"
import style0 from "./extremeRules.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports